import { render, staticRenderFns } from "./NfisCard.vue?vue&type=template&id=3847cdec&scoped=true&"
import script from "./NfisCard.vue?vue&type=script&lang=js&"
export * from "./NfisCard.vue?vue&type=script&lang=js&"
import style0 from "./NfisCard.vue?vue&type=style&index=0&id=3847cdec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3847cdec",
  null
  
)

export default component.exports